import { apiService } from '../../../services/api';
import type { ReportDownloadResponse } from '../types';
import { getReportCopy } from './reportCopy';
import { isSafeReportDownloadUrl } from './urlSafety';

export async function getReportDownload(
  jobId: string,
): Promise<ReportDownloadResponse> {
  const response = await apiService.downloadReportJob(jobId);

  if (!isSafeReportDownloadUrl(response.downloadUrl)) {
    throw new Error(getReportCopy('es-ES').errors.unsafeDownload);
  }

  return response;
}
